export default function AboutHero() {
  return (
    <section
      className="relative h-96 flex items-end lg:pb-[70px] pb-0 lg:pl-[140px] pl-[0px] items-center lg:items-end lg:justify-start justify-center text-white"
      style={{
        backgroundImage: `linear-gradient(90deg, #022843 0%, rgba(2, 40, 67, 0) 100%), url('https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770027201/5876d9f779d5215a8b5363d48db7448b3697b9ed_x7m5zk.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="relative z-10  px-6 lg:text-left text-center">
        <h1 className="text-3xl lg:text-[50px] font-medium mb-4">About Us</h1>
      </div>
    </section>
  );
}
